export default __webpack_public_path__ + "static/media/sasaki-logo.b6e1a633.svg";